import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/71_card_back_classic_blue/71_card_back_classic_blue"
 * Contains 1 texture(s)
 */
export class CardsBacks71CardBackClassicBlueAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/71_card_back_classic_blue/71_card_back_classic_blue';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '71_classic_blue.png'
    ] as const;
}
